import React from 'react';
import { footerLinkClassName, homepageSectionContainerClassName } from '../constants/homepageUi';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-gray-900 text-gray-300 py-12">
      <div className={homepageSectionContainerClassName}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-5 flex items-center space-x-2.5">
              <img
                src="/pix-logo.png"
                alt="Pixano Logo"
                className="h-14 w-14 object-contain sm:h-[3.75rem] sm:w-[3.75rem]"
              />
              <span className="text-2xl font-bold tracking-tight text-white sm:text-[1.65rem]">Pixano</span>
            </div>
            <p className="mb-3 text-sm text-gray-300">Real-World Data Infrastructure for AI</p>
            <p className="text-sm text-gray-300">
              © {currentYear} Pixano AI LLC. All rights reserved.
            </p>
            <h3
              className="relative mb-3 mt-8 inline-block pb-2 text-sm font-semibold text-white after:absolute after:left-0 after:bottom-0 after:h-px after:w-10 after:max-w-[2.5rem] after:bg-[#00e3ff]/45"
            >
              Contact
            </h3>
            <a href="mailto:support@pixano.ai" className={footerLinkClassName}>
              support@pixano.ai
            </a>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wide mb-3">
              Explore
            </h3>
            <div className="space-y-2">
              <a href="/" className={footerLinkClassName}>
                Home
              </a>
              <a href="/#training-data" className={footerLinkClassName}>
                Training Data
              </a>
              <a href="/for-businesses" className={footerLinkClassName}>
                For Businesses
              </a>
              <a href="/for-contributors" className={footerLinkClassName}>
                For Contributors
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wide mb-3">
              Legal
            </h3>
            <div className="space-y-2">
              <a href="/terms" className={footerLinkClassName}>
                Terms of Service
              </a>
              <a href="/privacy" className={footerLinkClassName}>
                Privacy Policy
              </a>
              <a href="/delete-account" className={footerLinkClassName}>
                Delete Account
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
